import $ from 'jquery'
import AjaxRequest from "../modules/ajax-request";
import Cookies from 'js-cookie';

class HeaderUserControls {
    constructor(element) {
        this.div = element;
        this.loggedContentUrl = "";
        this.logoutUrl = "";
        this.logoutId = "";
        this.logoutButton = "";
        this.getData();
        this.clearData();
        this.bindEvents();
        this.init();
    }

    getData() {
        this.loggedContentUrl = $(this.div).data("render-logged-content-url");
        this.logoutId = '[data-id="mainheader__logout"]';
    }

    clearData() {
        $(this.div).removeAttr("data-render-logged-content-url");
    }

    bindEvents() {
        var _this = this;
        $('header [data-logout-button]').on("click", function () {
            _this.doLogout();
        });
    }

    init() {
        if (parseInt(Cookies.get("cs_logged")) === 1) {
            this.renderLoggedContent();
        }
    }

    doLogout() {
        var _ajaxRequest = new AjaxRequest({
            successCallback: function () {
                Cookies.remove("cs_logged");
                Cookies.remove("cs_adv");
                location.reload();
            }
        });
        _ajaxRequest.makeCall(this.logoutUrl);
    }

    renderLoggedContent() {
        var _ulLinks = $(this.div).find('[data-not-logged]');
        if (_ulLinks.length > 0) {
            var _this = this;
            var _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    $('header [data-not-logged]').html(response.message);
                    var _logoutButton = $('header').find('[data-id="mainheader__logout"]');
                    _this.logoutUrl = $(_logoutButton).data("logout-url");
                    // $(_logoutButton).removeAttr("data-logout-url");
                    $('body').addClass('is-logged');
                    this.logoutButton = $('header [data-logout-button]');
                    _this.bindEvents();
                },
                errorCallback: function (response) {
                    Cookies.remove("cs_logged");
                    Cookies.remove("cs_adv");
                }
            });
            _ajaxRequest.makeCall(this.loggedContentUrl);
        }
    }
}

export default HeaderUserControls;